module.exports = __webpack_public_path__ + "static/media/Seaking_gaussian2.d3900966.png";